// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mediaRequestSpokespersonEntity from './entities/media-request-spokesperson.json';
import mediaRequestSpokespersonMenu from '../pages/media-request-spokesperson/menu.json';
import mediaRequestSpokespersonFullForm from '../pages/media-request-spokesperson/forms/full.json';
import mediaRequestSpokespersonContextForm from '../pages/media-request-spokesperson/forms/context.json';
import mediaRequestSpokespersonMiniForm from '../pages/media-request-spokesperson/forms/mini.json';
import mediaRequestSpokespersonLookupForm from '../pages/media-request-spokesperson/forms/lookup.json';
import mediaRequestSpokespersonTableView from '../pages/media-request-spokesperson/views/table.json';
import mediaRequestSpokespersonCardsView from '../pages/media-request-spokesperson/views/cards.json';
import mediaRequestSpokespersonCalendarView from '../pages/media-request-spokesperson/views/calendar.json';
import mediaRequestSpokespersonDashboardView from '../pages/media-request-spokesperson/views/dashboard.json';

/** Тип запису «Речник» зі сторінками пакета: меню, форми та подання з pages/media-request-spokesperson/. */
export const mediaRequestSpokespersonDefinition: IRecordTypeDefinition = {
  ...mediaRequestSpokespersonEntity,
  views: assembleViewSet({
      table: mediaRequestSpokespersonTableView,
      cards: mediaRequestSpokespersonCardsView,
      calendar: mediaRequestSpokespersonCalendarView,
      dashboard: mediaRequestSpokespersonDashboardView,
  }),
  form: mediaRequestSpokespersonFullForm,
  forms: { full: mediaRequestSpokespersonFullForm, context: mediaRequestSpokespersonContextForm, mini: mediaRequestSpokespersonMiniForm, lookup: mediaRequestSpokespersonLookupForm },
  menu: mediaRequestSpokespersonMenu,
} as IRecordTypeDefinition;
